<template>
  <div class="taskInfo" v-if="infoData">
    <new-head class="pos-top" zai="false" title="任务详情">
      <template slot="right">
        <span style="font-size: 14px" @click="$router.push('/share?task_id=7577')"
          >转发任务</span
        >
      </template>
    </new-head>
    <div class="top">
      <div class="taskName">{{ infoData.title }}</div>
      <div class="time">{{ infoData.time }}</div>
      <ul>
        <li class="labels">
          <div class="label fontCenter color1">{{ infoData.task_mech }}</div>
          <template v-if="infoData.task_tag">
            <div
              class="label fontCenter color2"
              v-for="(item, i) in strToArr(infoData.task_tag)"
              :key="i"
            >
              {{ item }}
            </div>
          </template>
          <div class="label fontCenter color3" v-if="infoData.urgent_level == '紧急'">
            {{ infoData.urgent_level }}
          </div>
        </li>
        <li class="prise">
          <img src="@/assets/image/prise.png" alt="" />
          <span> {{ moneyFormat(infoData.award) }}</span>
        </li>
      </ul>
    </div>
    <div class="content">
      <div class="contentLabels">
        <div
          class="contentLabel fontCenter"
          v-for="(item, i) in tabList"
          :key="i"
          :class="{ contentLabelActive: tabIndex == item }"
          @click="tabIndex = item"
        >
          {{ item }}
        </div>
      </div>
      <template v-if="tabIndex == '领取详情'">
        <p class="receiveNum">
          (领取人数：{{ infoData.receive_limit.pink }}
          <span v-if="infoData.receive_limit.max_pick"
            >/{{ infoData.receive_limit.max_pick }}</span
          >
          )
        </p>
        <el-table :data="infoData.receive_list" border style="width: 100%">
          <el-table-column prop="realname" label="领取人"> </el-table-column>
          <el-table-column prop="day" label="领取时间" width="90"> </el-table-column>
          <el-table-column prop="pay_text" label="领取状态"> </el-table-column>
          <el-table-column prop="award" label="奖励金额">
            <template slot-scope="scope">
              {{ moneyFormat(scope.row.award) }}
            </template>
          </el-table-column>
        </el-table>
        <!-- <my-table :tableHead="tableHead" :tableData="infoData.receive_list"></my-table> -->
      </template>
      <template v-if="tabIndex == '任务详情'">
        <div class="infoItems">
          <div class="infoItem">
            <div class="itemLabel">发布人:</div>
            <p>{{ infoData.createby_name }}</p>
          </div>
          <div class="infoItem">
            <div class="itemLabel">发布人日期:</div>
            <p>
              {{ infoData.create_time ? infoData.create_time.substr(0, 10) : "" }}
            </p>
          </div>
          <div class="infoItem">
            <div class="itemLabel">任务状态:</div>
            <p class="status">{{ infoData.status }}</p>
          </div>
          <div class="infoItem">
            <div class="itemLabel">维护期:</div>
            <p>{{ infoData.maintain_days }}个工作日</p>
          </div>
        </div>
        <div class="item">
          <div class="itemLabel">任务说明:</div>
          <div
            class="itemMain"
            id="content"
            v-html="infoData.content"
            :class="{ close: contentFlag == 1 }"
          ></div>
        </div>
        <template v-if="contentFlag">
          <div class="openCloseBtn">
            <span v-if="contentFlag == 1" @click="contentFlag = 2">更多...</span>
            <span v-if="contentFlag == 2" @click="contentFlag = 1">收起</span>
          </div>
        </template>
        <div class="item">
          <div class="itemLabel">验收标准:</div>
          <div
            class="itemMain"
            id="criteria"
            v-html="infoData.criteria"
            :class="{ close: criteriaFlag == 1 }"
          ></div>
        </div>
        <template v-if="criteriaFlag">
          <div class="openCloseBtn">
            <span v-if="criteriaFlag == 1" @click="criteriaFlag = 2">更多...</span>
            <span v-if="criteriaFlag == 2" @click="criteriaFlag = 1">收起</span>
          </div>
        </template>
        <div class="item" v-if="infoData.TaskFiles.length">
          <div class="itemLabel">背景材料:</div>
          <div class="itemMain">
            <!-- Documentation -->
            <p v-for="(item, index) in infoData.TaskFiles" :key="index">
              <a class="documentation" :href="item.file_path">{{ item.original_name }}</a>
            </p>
          </div>
        </div>
        <div class="item">
          <div class="itemLabel">提示:</div>
          <div class="itemMain">
            实际发放金额=总金额*评分/10-个税-增值税-转发奖励 你的任务与你的评分得分有关。
          </div>
        </div>
      </template>
      <template v-if="tabIndex == '评审情况'">
        <div class="review">
          <div class="fractionCard flex-center">评分 8分</div>
          <h3>评审意见</h3>
          <p>
            具体的评审意见具体的评审意见具体的评审意见具体的评审意见具体的评审意见具体的评审意见
          </p>
          <div class="line"></div>
          <h4>提示</h4>
          <div class="tip">
            实际发放金额=总金额*评分/10-个税-增值税-转发奖 <br />
            你的任务与你的评分得分
          </div>
        </div>
      </template>
    </div>
    <div class="bottomBtn" v-if="type == 0">
      <div class="flex-center" @click="callPhone(infoData.createby_mobile)">电话沟通</div>
      <div class="receive flex-center" @click="receive">
        <span class="fontCenter" :class="{ can: isReceiveFn(infoData).isReceive }">
          {{ isReceiveFn(infoData).statusText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getIdTaskApi, getInTask } from "@/api/api/task";
export default {
  components: {},
  data() {
    return {
      type: 0, //1:我的发布进入  2: 我的领取进入
      tabIndex: "任务详情",
      tabList: ["任务详情"],
      tableHead: [
        {
          text: "领取人",
          props: "realname",
        },
        {
          text: "领取时间",
          props: "day",
        },
        {
          text: "领取状态",
          props: "pay_text",
        },
        {
          text: "奖励金额",
          props: "award",
        },
      ],
      tableData: [],
      taskId: null,
      infoData: null,
      contentFlag: null,
      criteriaFlag: null,
    };
  },
  created() {
    let type = this.$route.query.type;
    if (type) {
      this.type = type;
      if (type == 1) {
        this.tabList.push("领取详情");
      } else if (type == 2) {
        // this.tabList.push("评审情况");
      }
    }

    this.taskId = this.$route.query.taskId;
    this.getData();
  },
  mounted() {},
  beforeDestroy() {},

  methods: {
    async getData() {
      let res = await getIdTaskApi(this.taskId);
      let data = res.data.data;
      data.time = `${data.plan_start_time
        .substring(0, 10)
        .split("-")
        .join("/")}-${data.plan_end_time.substring(0, 10).split("-").join("/")}`;
      this.infoData = data;
      console.log({ ...data });
      this.$nextTick(() => {
        let maxHeight = 40;
        if (document.getElementById("content").offsetHeight > maxHeight)
          this.contentFlag = 1;
        if (document.getElementById("criteria").offsetHeight > maxHeight)
          this.criteriaFlag = 1;
      });
    },
    callPhone(e) {
      window.location.href = "tel://" + e + "";
    },
    async receive() {
      if (this.isReceiveFn(this.infoData).isReceive) {
        let res = await getInTask(this.taskId);
        console.log(res);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  font-size: 12px;
}

/deep/.el-table .el-table__cell {
  padding: 8px 0;
}

.close {
  max-height: 40px;
  overflow: hidden;
}

.openCloseBtn {
  color: #0286ff;
  text-align: right;
}

.taskInfo {
  letter-spacing: 0px;
  min-height: 100%;
  // background: #f6f6f4;
  padding: 57px 18px 0;

  .top {
    border-bottom: 1px solid #d8d8d8;
    padding-bottom: 14px;

    .taskName {
      font-size: 14px;
      line-height: 20px;
    }

    .time {
      font-size: 11px;
      color: #979797;
      margin-top: 4px;
    }

    ul {
      display: flex;
      margin-top: 7px;
      align-items: center;

      .labels {
        display: flex;
        flex: 1;

        .label {
          height: 16px;
          padding: 0 8px;
          border-radius: 50%;
          font-size: 10px;
          color: #ffffff;
          margin-right: 5px;
        }
      }

      .prise {
        display: flex;
        align-items: center;

        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }

        span {
          font-size: 20px;
          font-weight: 600;
          color: #ff7a15;
        }
      }
    }
  }

  .content {
    padding-top: 14px;
    font-size: 13px;

    .contentLabels {
      display: flex;

      .contentLabel {
        width: 69px;
        height: 22px;
        text-align: center;
        background: #cacaca;
        border-radius: 3px;
        font-size: 13px;
        color: #fff;
        margin-right: 11px;
      }

      .contentLabelActive {
        background-color: #0286ff;
      }
    }

    .receiveNum {
      font-size: 12px;
      color: #333333;
      margin: 20px 0 11px 0;
    }

    .infoItems {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;

      .infoItem {
        display: flex;
        width: 50%;
        margin-top: 7px;

        .itemLabel {
          width: 75px;
          text-align: right;
          line-height: 19px;
          padding-right: 2px;
        }

        p {
          line-height: 19px;
        }

        .status {
          color: #0286ff;
        }
      }
    }

    .item {
      display: flex;
      margin-top: 14px;

      .itemLabel {
        width: 67px;
        text-align: right;
        line-height: 19px;
        padding-right: 2px;
      }

      .itemMain {
        flex: 1;
        font-size: 13px;
        line-height: 19px;
        color: #333333;

        .documentation {
          color: #0286ff;
        }
      }
    }
  }

  .bottomBtn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 47px;
    display: flex;

    > div {
      width: 95px;
      height: 100%;
      background: #e9f2ff;
      border: 1px solid #0286ff;
      font-size: 12px;
      color: #0286ff;
    }

    .receive {
      flex: 1;
      color: #fff;
      border: none;

      span {
        display: block;
        width: 100%;
        height: 100%;
        background-color: #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .can {
        background-color: #0286ff;
      }
    }
  }

  .review {
    .fractionCard {
      margin-top: 19px;
      height: 140px;
      background: #ffffff;
      box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 7px;
      font-size: 30px;
      color: #333;
      font-weight: 600;
    }

    h3 {
      font-size: 13px;
      margin-top: 24px;
    }

    p {
      font-size: 13px;
      line-height: 20px;
      margin-top: 9px;
    }

    .line {
      width: 100vw;
      height: 1px;
      background: #d8d8d8;
      margin: 22px 0;
      margin-left: -18px;
    }
    h4 {
      margin-bottom: 10px;
    }
    .tip {
      line-height: 20px;
    }
  }
}
</style>
